import React, { createContext, useState } from 'react'
import { createChatMessageStore } from './ChatMessageStore'

export interface ChatMessageStoreContextProps {
    chatInstanceId: string
    chatMessageStores: Map<string, ReturnType<typeof createChatMessageStore>>
}

export const ChatMessageStoreContext = createContext<
    ChatMessageStoreContextProps
>({} as ChatMessageStoreContextProps)

export interface ChatMessageStoreProviderProps {
    chatInstanceId: string
    children: React.ReactNode
}

export const ChatMessageStoreProvider: React.FC<ChatMessageStoreProviderProps> = ({
    chatInstanceId,
    children,
}) => {
    const [storeInstance] = useState<ChatMessageStoreContextProps>({
        chatInstanceId,
        chatMessageStores: new Map(),
    })

    return (
        <ChatMessageStoreContext.Provider value={storeInstance}>
            {children}
        </ChatMessageStoreContext.Provider>
    )
}
